
<template>
    <div class="body-panel dataContent">
        <template v-if="material != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back">
                            <router-link :to="'/materials/' + $route.params.id">Назад к материалу</router-link>
                        </p>
                    </div>
                </div>
                <div class="control-block-right">
                    <button class="btn m-float-left" type="button" style="min-width:120px;"
                            @click="onStartTest"
                            v-if="!started && !material.AllowedAttemptTime && (!material.TestAttemptsNumber || material.Attempt <= material.TestAttemptsNumber)">
                        {{ material.TestButtonName || 'Пройти тест' }}
                    </button>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel page-content-block qwestions">
                    <div class="test-start" v-if="!started && material != null && results == null">
                        <div class="test-hello flex margin-bottom-20" v-if="material.TestGreeting">
                            <p class="test-hello-text" v-html="formatLine(material.TestGreeting)"></p>
                        </div>
                        <div>
                            <div class="test-stats-row flex">
                                <div class="test-stats-cell">
                                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Time"></use>
                                    </svg>
                                    <p class="margin-top-10 caption-help">Время теста</p>
                                    <p class="margin-top-5 p-header-1">{{ material.TestTime ? material.TestTime + ' ' + get_text_ending(material.TestTime, ['минута','минуты','минут']) : 'без ограничений' }}</p>
                                </div>
                                <div class="test-stats-cell">
                                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Hash"></use>
                                    </svg>
                                    <p class="margin-top-10 caption-help">Номер попытки</p>
                                    <p class="margin-top-5 p-header-1">
                                        {{ material.Attempt }}
                                        <template v-if="material.TestAttemptsNumber">
                                            / {{material.TestAttemptsNumber}}
                                        </template>
                                    </p>
                                    <p class="margin-top-5 p-header-1" v-if="material.AllowedAttemptTime">
                                        Следующая попытка доступна в {{ formatDate(material.AllowedAttemptTime, 'DD.MM.YYYY HH:mm:ss') }}
                                    </p>
                                </div>
                            </div>
                            <div class="test-stats-row flex">
                                <div class="test-stats-cell">
                                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Check"></use>
                                    </svg>
                                    <p class="margin-top-10 caption-help">Всего вопросов</p>
                                    <p class="margin-top-5 p-header-1">{{ material.QuestionsToAsk ? material.QuestionsToAsk: material.Questions.length }}</p>
                                </div>
                                <div class="test-stats-cell" v-if="material.Bonus">
                                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                    </svg>
                                    <p class="margin-top-10 caption-help">Максимум баллов</p>
                                    <p class="margin-top-5 p-header-1">{{ material.Bonus }}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div v-if="started && material != null && currentState.question != null" class="flex mob-flex-to-block" style="height:100%;position:relative">
                        <div class="test-qwestion">
                            <div class="test-name margin-bottom-15">{{material.Name}}</div>
                            <div class="test-qwestion-num"><span>{{ currentState.index }}</span> / {{ material.Questions.length }}</div>

                            <div class="background-image" v-if="currentState.question.BackgroundSite.FilePath">
                                <img :src="currentState.question.BackgroundSite.FilePath" />
                                <p :class="[{'top': currentState.question.BackgroundSite.Align === 'top' }, {'bottom': currentState.question.BackgroundSite.Align === 'bottom' }]">{{currentState.question.Description}}</p>
                            </div>
                            <p v-else class="test-qwestion-text">{{ currentState.question.Description }}</p>

                            <div v-if="currentState.question.Images.length" class="margin-top-20 margin-bottom-20">
                                <a class="lightzoom" rel="group" v-for="image of currentState.question.Images" :href="image.Image">
                                    <img style="max-width: 200px; margin-right: 10px;" :src="image.Image" />
                                </a>
                            </div>

                            <div class="margin-top-30">
                                <template v-for="answer of currentState.question.Answers">
                                    <template v-if="currentState.question.QuestionType === 1">
                                        <div class="form-field">
                                            <input type="radio" class="input-checkbox"
                                                   :id="'Answer_q' + currentState.question.Id  + 'a' + answer.Id"
                                                   :name="'Answer_q' + currentState.question.Id  + 'a' + answer.Id"
                                                   v-model="currentState.answers"
                                                   :value="answer.Id" />
                                            <label :for="'Answer_q' + currentState.question.Id  + 'a' + answer.Id" class="input-checkbox-lbl">{{ answer.Value }}</label>
                                        </div>
                                    </template>
                                    <template v-if="currentState.question.QuestionType === 2">
                                        <div class="form-field">
                                            <input type="checkbox" class="input-checkbox"
                                                   :id="'Answer_q' + currentState.question.Id  + 'a' + answer.Id"
                                                   :name="'Answer_q' + currentState.question.Id  + 'a' + answer.Id"
                                                   v-model="currentState.answers"
                                                   :value="answer.Id" />
                                            <label :for="'Answer_q' + currentState.question.Id  + 'a' + answer.Id" class="input-checkbox-lbl">{{ answer.Value }}</label>
                                        </div>
                                    </template>
                                </template>

                                <template v-if="currentState.question.QuestionType === 3">

                                    <input type="text" class="input-text"
                                           :name="'QuestionFreeAnswer'"
                                           v-model="currentState.answers"
                                           v-if="currentState.question.AnswerType === 1" key="type1" />

                                    <input type="text" key="type2"
                                           :name="'QuestionFreeAnswer'"
                                           v-model="currentState.answers"
                                           v-if="currentState.question.AnswerType === 2"
                                           v-validate="{ regex: /^\d{1,}$/ }" :class="['input-text', {'input-error': errors.has('QuestionFreeAnswer') }]" />

                                    <input type="text" key="type3"
                                           :name="'QuestionFreeAnswer'"
                                           v-model="currentState.answers"
                                           v-if="currentState.question.AnswerType === 3"
                                           v-validate="{ regex: /^\d{1,}(\.|\,)?\d{0,}$/ }" :class="['input-text', {'input-error': errors.has('QuestionFreeAnswer') }]" />

                                    <input-date key="type4"
                                                :name="'QuestionFreeAnswer'"
                                                v-model="currentState.answers"
                                                :class="[{'input-error': errors.has('answers')}]"
                                                v-if="currentState.question.AnswerType === 4"></input-date>

                                </template>
                            </div>
                            <div class="btns margin-top-30">
                                <button class="btn" v-if="currentState.index !== material.Questions.length" @click="makeAnswer()">Следующий вопрос</button>
                                <button class="btn" v-if="currentState.index === material.Questions.length" @click="makeAnswer()">Завершить тест</button>
                            </div>
                        </div>
                        <div class="test-timer" v-if="(material.Bonus || material.TestTime) ">
                            <div class="test-timer-block" v-if="material.Bonus">
                                <base-counter name="bonusCounter" :value="bonus" :max="material.Bonus" color="#1fa7e3" legend="Баллы" :compact="isMobile"></base-counter>
                                <!--<p class="caption-help">Баллы</p>-->
                                <transition name="fade">
                                <div class="ball-animate add" v-show="bonusAdd">
                                    <div class="flex">
                                        <div class="plus">+</div>
                                        <div class="text">{{bonusDx}}</div>
                                    </div>
                                    <svg class="star star-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                    </svg>
                                    <svg class="star star-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                    </svg>
                                    <svg class="star star-3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                    </svg>
                                    <svg class="star star-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                    </svg>
                                    <svg class="star star-5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                    </svg>
                                </div>
                                </transition>
                                <transition name="fade">
                                <div class="ball-animate del" v-show="bonusDel">
                                    <div class="flex">
                                        <div class="plus">-</div>
                                        <div class="text">{{-bonusDx}}</div>
                                    </div>
                                </div>
                                </transition>
                            </div>

                            <div class="test-timer-block"  v-if="material.TestTime">
                                <base-counter name="timeCounter" :value="time" :max="material.TestTime * 60" type="time" color="#68c45f" legend="Время" :compact="isMobile"></base-counter>
                                <!--<p class="caption-help">Время</p>-->
                            </div>
                        </div>
                    </div>

                    <div v-if="results != null">
                        <div class="test-result-header flex">
                            <div :class="['test-result-header-div', {'select': resultTabs.active === 'info'}]" @click="resultTabs.active='info'">Результаты теста</div>
                            <div v-if="material.TestDisplayRating" :class="['test-result-header-div', {'select': resultTabs.active === 'top'}]" @click="resultTabs.active='top'">ТОП-10</div>
                            <div v-if="material.TestDisplayStats" :class="['test-result-header-div', {'select': resultTabs.active === 'answers'}]" @click="resultTabs.active='answers'">Ваши ответы</div>
                        </div>
                        <div class="test-result-body">
                            <div :style="{display: resultTabs.active === 'info' ? 'block' : 'none'}">
                                <div class="test-result-body-header flex">
                                    <div class="test-result-body-icon">
                                        <svg class="svg-icon" v-if="results.Complete" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#ResultOk"></use>
                                        </svg>
                                        <svg class="svg-icon err" v-if="!results.Complete" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#ResultErr"></use>
                                        </svg>
                                    </div>
                                    <div class="test-result-body-text">
                                        <p class="caption-help">Тест завершён!</p>
                                        <p class="test-hello-text" v-if="!results.Complete">Вы не сдали тест</p>
                                        <p class="test-hello-text" v-if="results.Complete">Вы сдали тест</p>
                                    </div>
                                </div>
                                <div class="test-stats-row flex margin-top-30">
                                    <div class="test-stats-cell">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Time"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Время теста</p>
                                        <p class="margin-top-5 p-header-1">{{ results.TestTime }}</p>
                                    </div>
                                    <div class="test-stats-cell">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Hash"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Номер попытки</p>
                                        <p class="margin-top-5 p-header-1">{{ results.Attempt }}</p>
                                    </div>
                                </div>
                                <div class="test-stats-row flex">
                                    <div class="test-stats-cell">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Check"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Статистика ответов</p>
                                        <p class="margin-top-5 p-header-1"><span>{{ results.QuestionsRight }} ({{results.QuestionsRightPercent}}%)</span> / {{ results.QuestionsRight + results.QuestionsWrong}}</p>
                                    </div>
                                    <div class="test-stats-cell" v-if="material.Bonus > 0 || results.BonusMessage != null">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                        </svg>
                                        <p class="margin-top-10 caption-help">Итого баллов</p>
                                        <p class="margin-top-5 p-header-1">{{ results.BonusMessage == null ? results.Bonus.toFixed(0) : results.BonusMessage }}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="material.TestDisplayRating" :style="{display: resultTabs.active === 'top' ? 'block' : 'none'}">
                                <div class="test-result-body-header flex">
                                    <div class="test-result-body-icon">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Cup"></use>
                                        </svg>
                                    </div>
                                    <div class="test-result-body-text">
                                        <p class="caption-help">Топ-10 специалистов</p>
                                        <p class="test-hello-text">Лучшие из лучших</p>
                                    </div>
                                </div>
                                <table v-if="!isMobile" class="table-view">
                                    <thead>
                                        <tr class="heading">
                                            <th></th>
                                            <th>#</th>
                                            <th></th>
                                            <th align="left">ФИО</th>
                                            <th>Время теста</th>
                                            <th>Статистика ответов</th>
                                            <th>Итого баллов</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) of results.Top10">
                                            <td align="center" class="result-icon">
                                                <svg v-if="item.Place === 1" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg#gold-icon"></use>
                                                </svg>
                                                <svg v-if="item.Place === 2" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg#silver-icon"></use>
                                                </svg>
                                                <svg v-if="item.Place === 3" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg#bronze-icon"></use>
                                                </svg>
                                            </td>
                                            <td align="center">{{item.Place}}</td>
                                            <td class="img userimg" align="center" style="padding:5px">
                                                <img :src="'/uploads/users/' + item.UserImage" v-if="item.UserImage != null" />
                                                <img src="../../../img/u57.png" v-if="item.UserImage === null" />
                                            </td>
                                            <td>{{item.UserFio}}</td>
                                            <td align="center">{{item.TestTime}}</td>
                                            <td align="center">{{ formatAnswerStats(item.QuestionsRight, item.QuestionsWrong) }}</td>
                                            <td align="center">{{item.Bonus}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="isMobile" class="table-div" v-for="(item, i) of results.Top10">
                                    <div class="flex" style="font-size:14px;font-weight:600">
                                        <div class="result-icon">
                                            <svg v-if="item.Place === 1" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <use xlink:href="/Content/dist/image_svg.svg#gold-icon"></use>
                                            </svg>
                                            <svg v-if="item.Place === 2" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <use xlink:href="/Content/dist/image_svg.svg#silver-icon"></use>
                                            </svg>
                                            <svg v-if="item.Place === 3" class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <use xlink:href="/Content/dist/image_svg.svg#bronze-icon"></use>
                                            </svg>
                                        </div>
                                        <div style="width:45px;min-width:45px">{{item.Place}}</div>
                                        <div style="width:100%;">{{item.UserFio}}</div>
                                    </div>
                                    <div class="flex margin-top-5 caption-help">
                                        <div style="width:50%">Время</div>
                                        <div style="width:50%;text-align:right">{{item.TestTime}}</div>
                                    </div>
                                    <div class="flex margin-top-2 caption-help">
                                        <div style="width:50%">Ответы</div>
                                        <div style="width:50%;text-align:right">{{ formatAnswerStats(item.QuestionsRight, item.QuestionsWrong) }}</div>
                                    </div>
                                    <div class="flex margin-top-2 caption-help">
                                        <div style="width:50%">Баллы</div>
                                        <div style="width:50%;text-align:right">{{item.Bonus}}</div>
                                    </div>
                                </div>

                            </div>
                            <div v-if="material.TestDisplayStats" :style="{display: resultTabs.active === 'answers' ? 'block' : 'none'}">
                                <div class="test-result-body-header flex">
                                    <div class="test-result-body-icon">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Qwestion"></use>
                                        </svg>
                                    </div>
                                    <div class="test-result-body-text">
                                        <p class="caption-help">Ваши ответы на вопросы</p>
                                        <p class="test-hello-text">Статистика ответов</p>
                                    </div>
                                </div>

                                <table v-if="!isMobile" class="table-view">
                                    <thead>
                                        <tr class="heading">
                                            <th>#</th>
                                            <th align="left">Вопрос</th>
                                            <th>Результат</th>
                                            <th>Время ответа</th>
                                            <th>Баланс</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) of results.Answers">
                                            <td align="center">{{i + 1}}</td>
                                            <td>{{item.QuestionDescription}}</td>
                                            <td align="center" :class="['qwestion-result', {'err': !item.Correct }]">{{item.Correct ? 'Верно': 'Не верно'}}</td>
                                            <td align="center">{{item.AnswerTime}}</td>
                                            <td align="center">{{item.Balance ? item.Balance.toFixed(0) : null }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-if="isMobile" class="table-div" v-for="(item, i) of results.Answers">
                                    <div class="flex caption-help">
                                        <div style="width:50%">Вопрос</div>
                                        <div style="width:50%;text-align:right"># {{i+1}}</div>
                                    </div>
                                    <div class="margin-top-5" style="font-size:14px;font-weight:600">
                                        {{item.QuestionDescription}}
                                    </div>
                                    <div class="flex margin-top-5">
                                        <div style="width:50%">Результат</div>
                                        <div style="width:50%;text-align:right" :class="['qwestion-result', {'err': !item.Correct }]">{{item.Correct ? 'Верно': 'Не верно'}}</div>
                                    </div>
                                    <div class="flex margin-top-2">
                                        <div style="width:50%">Время ответа</div>
                                        <div style="width:50%;text-align:right">{{item.AnswerTime}}</div>
                                    </div>
                                    <div class="flex margin-top-2" v-if="item.Balance">
                                        <div style="width:50%">Баллы</div>
                                        <div style="width:50%;text-align:right">{{item.Balance.toFixed(0)}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>
        <vue-headful title="Тест" />
    </div>
</template>


<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    let backendApi = new BackendApi();
    import imgMixin from '../../helpers/img-mixin'

    let sessionTimeOut = null,
        secondsInterval = null;

    export default {
        name: "material-test",

        props: ['info'],

        mixins: [imgMixin],

        data() {
            return {
                material: null,
                started: false,
                currentState: {
                    question: null,
                    index: null,
                    answers: []
                },
                materialTestSessionId: null,
                results: null,
                bonus: null,
                time: null,
                resultTabs: {
                    active: 'info'
                },
                bonusAdd: false,
                bonusDel: false,
                bonusDx: 0,
                bonusAnimationTimeout: null,
                isMobile: UI.check_mobile(),
                makingAnswerProgress: false
            }
        },

        beforeRouteLeave (to, from, next) {
            if (this.started) {
                if (confirm('Вы уверены, что хотите уйти?')) {
                    next();
                }
            } else {
                next();
            }
        },

        methods: {
            formatAnswerStats(questionsRight, questionsWrong) {
                let count = questionsRight + questionsWrong;
                let questionsRightPercent = questionsRight * 100 / ( count === 0 ? 1: count);

                return questionsRight + ' (' + questionsRightPercent.toFixed(2) + '%) / ' + count;
            },

            showBonusAdd(dx){
                let vm = this;

                this.bonusDx = dx;
                if(dx > 0){
                    this.bonusAdd = true;
                    this.bonusDel = false;
                    window.clearTimeout(this.bonusAnimationTimeout);
                    this.bonusAnimationTimeout = window.setTimeout(function () {
                        vm.bonusAdd = false;
                    }, 3000);
                }
                else{
                    this.bonusDel = true;
                    this.bonusAdd = false;
                    window.clearTimeout(this.bonusAnimationTimeout);
                    this.bonusAnimationTimeout = window.setTimeout(function () {
                        vm.bonusDel = false;
                    }, 1900);
                }
            },

            formatLine(text){
                return text ? text.replace(/\n/g, '<br>'): null;
            },

            onChangeDate(item){
                item['answers'] =  moment(item['date'], 'DD.MM.YYYY').format('DD.MM.YYYY');
            },

            loadMaterial() {
                let vm = this;
                let id = parseInt(this.$route.params.id);
                return this.callApiWrapper(backendApi.materialLoad(id, true)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке материала');
                    }
                    else {
                        if (response.data == null) {
                            vm.$router.push('/materials');
                        }
                        else {
                            if(response.data.TestComplete){
                                vm.$router.push('/materials/' + id + '/testresults');
                            }

                            vm.material = response.data;

                            vm.time = response.data.TestTime * 60;
                            vm.bonus = response.data.Bonus;

                            //vm.onStartTest();
                        }
                    }
                })
            },

            onStartTest(){
                this.started = true;
                this.startTest();
            },

            startTest() {
                let vm = this;
                let materialId = this.$route.params.id;

                this.callApiWrapper(backendApi.materialStartTest(materialId)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка запуска теста');
                    }
                    else {
                        vm.materialTestSessionId = response.data;
                        vm.currentState.index = 1;
                        vm.currentState.question = vm.material.Questions[0];

                        vm.$nextTick(() => {
                            vm.imgmixin_lightzoomInit();
                        });

                        window.clearInterval(sessionTimeOut);
                        sessionTimeOut = window.setInterval(function () {

                            vm.updateTestSession();

                        }, 5000);


                        if(vm.time){
                            window.clearInterval(secondsInterval);
                            secondsInterval = window.setInterval(function(){

                                vm.time--;

                                if(vm.material.TestSecondBonus) {
                                    vm.bonus -= vm.material.TestSecondBonus;
                                }

                                vm.checkBonusAndTime();


                            }, 1000);
                        }

                    }
                });

            },

            checkBonusAndTime(){
                let vm = this;

                if(vm.material.Bonus) {
                    if (vm.bonus > vm.material.Bonus) {
                        vm.bonus = vm.material.Bonus;
                    }
                    if (vm.bonus < 0) {
                        vm.bonus = 0;
                    }
                }

                if((vm.material.TestTime && vm.time <= 0) || (vm.material.Bonus && vm.bonus <= 0)){
                    // тест закончен
                    vm.callApiWrapper(backendApi.materialFailTestSession(vm.materialTestSessionId)).then(function (response) {
                        if (response.hasError) {
                            console.error('materialFailTestSession', response);
                        }
                        else {

                            vm.results = response.data;

                            let totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                            vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);

                            vm.currentState = {
                                question: null,
                                index: null,
                                answers: []
                            };

                            vm.started = false;

                            if(vm.$route.query.start !== undefined){
                                vm.$router.push('/materials/' + id + '/?tab=results');
                            }
                        }
                    });

                    window.clearInterval(secondsInterval);
                    window.clearInterval(sessionTimeOut);
                }
            },

            updateTestSession() {
                this.callApiWrapper(backendApi.materialUpdateTestSession(this.materialTestSessionId));
            },

            makeAnswer() {
                let vm = this;

                if(vm.makingAnswerProgress){
                    return;
                }

                let obj = {
                    MaterialTestSessionId: vm.materialTestSessionId,
                    QuestionId: vm.currentState.question.Id,
                    Answers: null
                };

                if (vm.currentState.answers.length === 0) {
                    UI.toastr.error('Необходимо указать ответ');
                    return;
                }

                vm.makingAnswerProgress = true;

                if (typeof vm.currentState.answers === 'object') {
                    obj.Answers = vm.currentState.answers
                } else {
                    obj.Answers = [vm.currentState.answers]
                }

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                        vm.makingAnswerProgress = false;
                    }
                    else {
                        this.callApiWrapper(backendApi.materialMakeAnswer(obj)).then(function (response) {
                            if (response.hasError && response.status !== 401) {
                                if (response.status === 702) {
                                    UI.toastr.error('На этот вопрос уже дан ответ');
                                }
                                else {
                                    UI.toastr.error('Ошибка во время обработки ответа');
                                }
                            }
                            else {

                                if (response.data.Correct === true && vm.material.TestRightAnswerBonus) {
                                    vm.bonus += vm.material.TestRightAnswerBonus;
                                    vm.checkBonusAndTime();
                                    vm.showBonusAdd(vm.material.TestRightAnswerBonus);
                                }
                                if (response.data.Correct === false && vm.material.TestWrongAnswerBonus) {
                                    vm.bonus -= vm.material.TestWrongAnswerBonus;
                                    vm.checkBonusAndTime();
                                    vm.showBonusAdd(-vm.material.TestWrongAnswerBonus);
                                }

                                if (vm.currentState.index === vm.material.Questions.length) {

                                    vm.results = response.data;

                                    let totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                                    vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);

                                    vm.currentState = {
                                        question: null,
                                        index: null,
                                        answers: []
                                    };

                                    vm.$emit('user-updated');

                                    window.clearInterval(sessionTimeOut);
                                    window.clearInterval(secondsInterval);

                                    vm.started = false;

                                    if(vm.$route.query.start !== undefined){
                                        vm.$router.push('/materials/' + vm.material.Id + '/?tab=results');
                                    }
                                }
                                else {
                                    vm.currentState.index++;
                                    vm.currentState.question = vm.material.Questions[vm.currentState.index - 1];
                                    vm.currentState.answers = [];

                                    vm.$nextTick(() => {
                                        vm.imgmixin_lightzoomInit();
                                    });
                                }
                            }

                            vm.makingAnswerProgress = false;
                        });
                    }
                });
            }
        },

        mounted() {
            let vm = this;

            UI.blockUI('.login-page-bg', 'Загрузка...');
            this.loadMaterial().then(() => {
                UI.unblockUI('.login-page-bg');

                if(this.$route.query.start !== undefined){
                    vm.onStartTest();
                }
            });

            // для теста вёрстки

            // vm.results = {
            //     Complete: true, // тест сдан
            //     QuestionsRightPercent: 33.33,
            //     QuestionsRight: 1,
            //     QuestionsWrong: 2,
            //     TestTime: '01:20',
            //     Attempt: 10,
            //     Bonus: 500,
            //     Rating: [
            //         { Fio: 'Fio - 1', TestTime: '1:23', StatsFormatted: '16 (100%) / 16', Bonus: 500},
            //         { Fio: 'Fio - 2', TestTime: '1:22', StatsFormatted: '16 (100%) / 16', Bonus: 400},
            //         { Fio: 'Fio - 3', TestTime: '1:21', StatsFormatted: '16 (100%) / 16', Bonus: 300},
            //         { Fio: 'Fio - 4', TestTime: '1:20', StatsFormatted: '16 (100%) / 16', Bonus: 200},
            //         { Fio: 'Fio - 5', TestTime: '1:19', StatsFormatted: '16 (100%) / 16', Bonus: 100}
            //     ],
            //     Answers: [
            //         { QuestionName: 'Вопрос-1', Correct: true, AnswerTime: '00:15' },
            //         { QuestionName: 'Вопрос-2', Correct: false, AnswerTime: '00:05' },
            //         { QuestionName: 'Вопрос-3', Correct: true, AnswerTime: '00:20' }
            //     ]
            // };
        },

        destroyed() {
            if (sessionTimeOut != null) {
                window.clearInterval(sessionTimeOut);
            }
            if (secondsInterval != null) {
                window.clearInterval(secondsInterval);
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/details/MaterialTest.vue